import * as dateFns from 'date-fns';

type DateInput = string | number | Date;

export const dateFormat = (date: DateInput, format: string = 'MMM d, yyyy') => {
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return dateFns.format(date, format);
};

export const dateFormatYearOnly = (date: DateInput) => {
    return dateFormat(date, 'yyyy');
};

export const dateFormatWithoutYear = (date: DateInput) => {
    return dateFormat(date, 'MMM d');
};

export const getWeeksInYear = (date: DateInput) => {
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return dateFns.getISOWeeksInYear(date);
};

/*
 *  Reference : https://date-fns.org/v2.21.1/docs/formatDistanceStrict
 *  Example output : '1 hour ago', '3 days ago'
 */
export const dateFormatDistanceToNow = (date: DateInput) => {
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return dateFns.formatDistanceStrict(date, new Date(), { addSuffix: true });
};